// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-wrapper[data-v-dcf00cac] {\n  max-height: calc(100vh - 340px) !important;\n}", ""]);
// Exports
module.exports = exports;
